"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisteredInspectionDetailDtoAttendanceStatusEnum = exports.RegisteredInspectionDetailDtoRegistrationTypeEnum = void 0;
exports.instanceOfRegisteredInspectionDetailDto = instanceOfRegisteredInspectionDetailDto;
exports.RegisteredInspectionDetailDtoFromJSON = RegisteredInspectionDetailDtoFromJSON;
exports.RegisteredInspectionDetailDtoFromJSONTyped = RegisteredInspectionDetailDtoFromJSONTyped;
exports.RegisteredInspectionDetailDtoToJSON = RegisteredInspectionDetailDtoToJSON;
exports.RegisteredInspectionDetailDtoToJSONTyped = RegisteredInspectionDetailDtoToJSONTyped;
var EnquiryDetailsListingInspectionDto_1 = require("./EnquiryDetailsListingInspectionDto");
/**
 * @export
 */
exports.RegisteredInspectionDetailDtoRegistrationTypeEnum = {
    PreRegistered: 'pre_registered',
    WalkIn: 'walk_in'
};
/**
 * @export
 */
exports.RegisteredInspectionDetailDtoAttendanceStatusEnum = {
    Pending: 'pending',
    Attended: 'attended',
    Unattended: 'unattended'
};
/**
 * Check if a given object implements the RegisteredInspectionDetailDto interface.
 */
function instanceOfRegisteredInspectionDetailDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('registrationType' in value) || value['registrationType'] === undefined)
        return false;
    if (!('isApproved' in value) || value['isApproved'] === undefined)
        return false;
    if (!('attendanceStatus' in value) || value['attendanceStatus'] === undefined)
        return false;
    if (!('listingInspection' in value) || value['listingInspection'] === undefined)
        return false;
    return true;
}
function RegisteredInspectionDetailDtoFromJSON(json) {
    return RegisteredInspectionDetailDtoFromJSONTyped(json, false);
}
function RegisteredInspectionDetailDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'registrationType': json['registrationType'],
        'isApproved': json['isApproved'],
        'name': json['name'] == null ? undefined : json['name'],
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'attendanceStatus': json['attendanceStatus'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'listingInspection': (0, EnquiryDetailsListingInspectionDto_1.EnquiryDetailsListingInspectionDtoFromJSON)(json['listingInspection']),
    };
}
function RegisteredInspectionDetailDtoToJSON(json) {
    return RegisteredInspectionDetailDtoToJSONTyped(json, false);
}
function RegisteredInspectionDetailDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'registrationType': value['registrationType'],
        'isApproved': value['isApproved'],
        'name': value['name'],
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'countryCode': value['countryCode'],
        'attendanceStatus': value['attendanceStatus'],
        'createdAt': value['createdAt'],
        'notes': value['notes'],
        'listingInspection': (0, EnquiryDetailsListingInspectionDto_1.EnquiryDetailsListingInspectionDtoToJSON)(value['listingInspection']),
    };
}
